// NkgKarte.tsx — „Neukundengewinnung (NKG)" in der Kontaktanlage: Soll zum neuen
// Interessenten gleich ein Vorgang vom Typ NKG angelegt werden? Inline-ja/nein
// statt Browser-Popup, Default „Nein". Seit 27.09.2026 bei Firma UND Privat.

import * as React from "react";
import { SectionCard } from "./formPrimitives";
import { StatusSegmented } from "./StatusSegmented";
import { REFINED } from "../risikoanalyseStep/tokens";

export function NkgKarte({ wert, onChange }: { wert: boolean; onChange: (v: boolean) => void }) {
  return (
    <SectionCard title="Neukundengewinnung (NKG)">
      <label style={{ display: "block", marginBottom: 8, color: REFINED.ink2, fontSize: 13 }}>
        Soll für diesen neuen Interessenten ein Vorgang vom Typ NKG (Neukundengewinnung) angelegt
        werden?
      </label>
      <StatusSegmented
        value={wert ? "Ja" : "Nein"}
        options={["Nein", "Ja"]}
        onChange={(v) => onChange(v === "Ja")}
        ariaLabel="NKG-Vorgang anlegen"
      />
    </SectionCard>
  );
}
